import { ref } from 'vue'
import type { Ref } from 'vue'

export type UseDropdownDirection = {
  buttonRef: Ref<HTMLElement | null>
  dropdownRef: Ref<HTMLElement | null>
  calculateDropdownVerticalPosition: () => void
  dropdownVerticalPosition: Ref<string>
}

export function useDropdownDirection(): UseDropdownDirection {
  const BUTTON_MENU_SPACING = 12
  const buttonRef = ref<HTMLElement | null>(null)
  const dropdownRef = ref<HTMLElement | null>(null)
  const dropdownVerticalPosition = ref<string>('')

  function calculateDropdownVerticalPosition() {
    const windowHeight = window.innerHeight
    const buttonElRect = buttonRef.value?.getBoundingClientRect()
    const dropdownRect = dropdownRef.value?.getBoundingClientRect()

    if (!buttonElRect || !dropdownRect) return

    const dropdownFitsBelow = buttonElRect.bottom + dropdownRect.height < windowHeight
    const dropdownFitsAbove = buttonElRect.top - dropdownRect.height > 0

    if (!dropdownFitsBelow && dropdownFitsAbove) {
      dropdownVerticalPosition.value = `${-dropdownRect.height - BUTTON_MENU_SPACING}px`
    } else {
      dropdownVerticalPosition.value = `${buttonElRect.height}px`
    }
  }

  return {
    buttonRef,
    dropdownRef,
    calculateDropdownVerticalPosition,
    dropdownVerticalPosition,
  }
}
